import { render, staticRenderFns } from "./ProductCardMoreInfo.vue?vue&type=template&id=e79a0c2c&scoped=true&"
import script from "./ProductCardMoreInfo.vue?vue&type=script&lang=js&"
export * from "./ProductCardMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardMoreInfo.vue?vue&type=style&index=0&id=e79a0c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79a0c2c",
  null
  
)

export default component.exports